<template>
  <login-wrapper>
    <detail-wrapper chamber="president"></detail-wrapper>
  </login-wrapper>
</template>

<script>
import { DetailWrapper } from '@/components'
import { LoginWrapper } from '@/components/common'

const name = 'president'

const components = {
  DetailWrapper,
  LoginWrapper
}

export default {
  name,
  components,
  metaInfo: {
    title: '2020 President Forecast'
  }
}
</script>
